import { isLegacyMuninInterfaceDetected } from "../../interfaces/LegacyMuninInterface";

export const isUwp = (): boolean => {
  console.debug("Checking if UWP environment");
  try {
    /* eslint-disable-next-line no-undef */
    if (Windows) {
      console.debug("WinRT API is present, detected UWP environment");
      return true;
    }
  } catch (error) {
    console.debug("Doesn't appear to be a UWP app");
  }
  return false;
};

export const isLegacyMunin = (): boolean => {
  // TODO: Look for the machine-ui JavaScript-Java interface
  console.debug("Checking if legacy Munin environment");
  return isLegacyMuninInterfaceDetected();
};

export const isNativeIos = (): boolean => {
  console.debug("Checking if iOS environment");

  if (window.webkit) {
    console.debug("Webkit API is present, detected iOS environment");
    return true;
  }

  return false;
};
